import TransactionDetailsContainer from "containers/MyGps/TransactionDetailsContainer/TransactionDetailsContainer"
import "./style.scss"

const TransactionDetailsScreen = () => {
  return <div className="screen-transaction-details">
    <TransactionDetailsContainer />
  </div>
}

export default TransactionDetailsScreen